<template>
  <button-block
      :btnClass='disabled ? "btn-secondary" : btnClass'
      :text='text'
      :textIcon="textIcon"
      :sm="sm"
      :disabled="disabled"
  />
</template>

<script>
import ButtonBlock from "./ButtonBlock";

export default {
  components: {ButtonBlock},
  data: function () {
    return {}
  },
  props: {
    btnClass: {
      type: String,
      default: 'btn-primary',
    },
    text: {
      type: String,
      default: 'Сохранить',
    },
    textIcon: {
      type: String,
      default: 'fas fa-save',
    },
    sm: Boolean,
    disabled: Boolean,
  },
  computed: {},
  mounted() {

  },
  methods: {}
}
</script>
